import simple from './simple.json';

export default { simple };
